export default __webpack_public_path__ + "static/services-1-d99fb345d2ab9d5b1572e3c37955183e.jpg";